/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useEffect } from 'react';
import cmsUtils from '../../cmsUtils';
import utils from '../../../../utils';
import { eventListStyle } from './eventListStyle';

export function EventList(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};
  
  const [eventList, setEventList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get sort parameter from CMS payload (ALL, Public, Private)
  const sort = cmsUtils.payload(item, 'Sort', 'all').toLowerCase();
  
  useEffect(() => {
    fetchEvents();
  }, [sort]);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await fetch(`/eventapi/event/getalleventforclient/${sort}`);
      if (!response.ok) {
        throw new Error('Failed to fetch events');
      }
      const data = await response.json();
      setEventList(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  if (loading) {
    return (
      <div css={eventListStyle.container}>
        <div css={eventListStyle.loading}>Loading events...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div css={eventListStyle.container}>
        <div css={eventListStyle.error}>Error loading events: {error}</div>
      </div>
    );
  }

  if (!eventList || eventList.length === 0) {
    return (
      <div css={eventListStyle.container}>
        <div css={eventListStyle.noEvents}>No events available at this time.</div>
      </div>
    );
  }

  return (
    <div css={eventListStyle.container} className="event-list-for-client-container" data-cms-item-id={cmsOption.isCmsEdit && item.itemId}>
      {eventList.map((eventModel, index) => (
        <div key={eventModel.eventId}>
          {index === 0 ? (
            // First event - show full details (like old midsec)
            <div css={eventListStyle.primaryEvent} className="event-list-for-client">
              <h4 css={eventListStyle.eventType} className="event-type">{eventModel.eventType} Registration</h4>
              <h2 css={eventListStyle.eventTitle} className="event-title">{eventModel.eventTitle}</h2>
              <div 
                css={eventListStyle.eventDescription}
                className="event-des"
                dangerouslySetInnerHTML={{ __html: eventModel.eventDes }}
              />
              <div css={eventListStyle.eventDetails} style={{ marginTop: '20px' }}>
                <div css={eventListStyle.eventDate} className="event-date">
                  <b>Date</b> : {formatDate(eventModel.eventDate)}
                </div>
                <div css={eventListStyle.eventTime} className="event-time" style={{ marginTop: '5px' }}>
                  <b>Time</b> : {eventModel.eventTime}
                </div>
                <div css={eventListStyle.eventPlace} className="event-place" style={{ marginTop: '5px' }}>
                  <b>Place</b> : {eventModel.eventPlace}
                </div>
                <div css={eventListStyle.registrationInfo} style={{ marginTop: '5px' }}>
                  Register to attend using the form below or call us on{' '}
                  <a href="tel:83777795" css={eventListStyle.phoneLink} style={{ fontWeight: '600' }}>8377 7795</a>.
                </div>
              </div>
              <button 
                type="button"
                css={eventListStyle.registerButton}
                className="btn btn-primary regbtn"
                onClick={() => window.location.href = `/event-form/${eventModel.eventId}`}
              >
                Register
              </button>
              {index + 1 !== eventList.length && <hr css={eventListStyle.separator} />}
            </div>
          ) : (
            // Subsequent events - show condensed format (like old midsec)
            <div css={eventListStyle.secondaryEvent} className="event-list-for-client-second">
              <div css={eventListStyle.secondaryEventTitle} className="event-title">{eventModel.eventTitle}</div>
              <button 
                type="button"
                css={eventListStyle.registerButton}
                className="btn btn-primary regbtn"
                onClick={() => window.location.href = `/event-form/${eventModel.eventId}`}
              >
                Register
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
